import React from 'react';
import './CSS/shop.css';

function Shop() {
  return (
    <div className="shop-container">	
      <div className="shop_grid_item title-grid-item">
        <article className="card pistachio">
          <h1 class="shop-title-card">Where can you find me?</h1>
        </article>
      </div>
      <div className="shop-grid">
        <div className="shop_grid_item">
          <article className="card independence">
            <a href="https://www.etsy.com/uk/shop/SombreroPrintmaking" class="shop-text-monoton underline" target="blank">Etsy</a>
          </article>
        </div>
        <div className="shop_grid_item">
          <article className="card red__salsa">
            <a href="https://www.ebay.co.uk/usr/sombrero_printmaking" class="shop-text-monoton underline" target="blank">Ebay</a>
          </article>
        </div>
        <div className="shop_grid_item">
          <article className="card zomp">
            <a href="https://www.facebook.com/kelhamislandbooks/" class="shop-text-monoton underline" target="blank">Kelham Island Books and Music</a>
          </article>
        </div>   
        <div className="shop_grid_item">
          <article className="card pansy__purple">
            <a href="http://www.weaveknitit.co.uk/" class="shop-text-monoton underline" target="blank">Weaveknitit Art Gallery</a>
          </article>
        </div> 
        <div className="shop_grid_item">
          <article className="card yellow__orange">
            <a href="https://cromfordmillcheeseshop.co.uk/" class="shop-text-monoton underline" target="blank">Cromford Mill Cheese Shop</a>
          </article>
        </div> 
        <div className="shop_grid_item">
          <article className="card queen__blue">
            <a href="http://www.thesoaploafcompany.com/" class="shop-text-monoton underline" target="blank">The Sugar Loaf Company</a>
          </article>
        </div> 
        <div className="shop_grid_item">
          <article className="card orange__red">
            <a href="http://www.delightful-decor.co.uk/" class="shop-text-monoton underline" target="blank">Delightful Decor</a>
          </article>
        </div> 
        <div className="shop_grid_item">
          <article className="card zomp">
            <a href="https://www.weststudios.co.uk/" class="shop-text-monoton underline" target="blank">West Studios</a>
          </article>
        </div> 
        <div className="shop_grid_item">
          <article className="card pistachio">
            <a href="https://www.tabbyteas.co.uk/" class="shop-text-monoton underline" target="blank">Tabby's Teas Cat Cafe</a>
          </article>
        </div> 
        <div className="shop_grid_item">
          <article className="card independence">
            <a href="https://www.facebook.com/OlympiaHouseAntiquesCraftCentre" class="shop-text-monoton underline" target="blank">Olympia House Antiques & Craft Centre</a>
          </article>
        </div> 
        <div className="shop_grid_item">
          <article className="card red__salsa">
            <a href="http://www.baslowpottery.co.uk/?fbclid=IwAR1i55LYB55cIix446lSbWwxZhQDN43uV3D8ZIXT1aMwVLOyLIj2Z6Wq0ms" class="shop-text-monoton underline" target="blank">Baslow Pottery</a>
          </article>
        </div> 
      </div>
    </div>
  );
}

export default Shop;
